import { Fragment } from 'react'
import Layout from 'components/layout'
import DraftStatusBar from './draft-status-bar'
import Dashboard, { STEP_GROUPS } from 'endpoints/dashboard'
import StepGroup from './step-group'
import Wait from 'components/wait'

const POLL_INTERVAL = 5000;

export default class extends React.Component {
  constructor() {
    super();
    this.pollDraftStatus = this.pollDraftStatus.bind(this);
    this.state = { status: null, releaseFiles: [], draftFiles: null, release: null, activeSteps: [] };
  }

  componentDidMount() {
    Dashboard.getRelease().then(({ release, files: releaseFiles }) => this.setState({ release, releaseFiles }));
    this.pollDraftStatus();
  }

  pollDraftStatus() {
    Dashboard.getDraftStatus().then(({ status, files: draftFiles, activeSteps })=> {
      this.setState({ status, draftFiles, activeSteps });
      this.pollTimeoutId = setTimeout(this.pollDraftStatus, POLL_INTERVAL);
    });
  }

  componentWillUnmount() {
    clearTimeout(this.pollTimeoutId);
  }

  render() {
    let content;
    if(this.state.draftFiles === null) {
      content = (<Wait />);
    } else {
      let { releaseFiles, draftFiles } = this.state;

      let panels = Object.keys(STEP_GROUPS).map((group, index) => {
        let files = draftFiles.reduce((acc, _draft) => {
          if(STEP_GROUPS[group].includes(_draft.type)) {
            let _release = releaseFiles.find(f => f.type === _draft.type);
            acc.push({ draft: _draft, release: _release });
          }
          return acc;
        }, []);

        return (
          <StepGroup
            key={group}
            group={group}
            index={index + 1}
            files={files}
            disabled={this.state.status === 'PROCESSING'}
            activeSteps={this.state.activeSteps}
          />
        );
      });
      content = (
        <Fragment>
          {panels}
          <DraftStatusBar status={this.state.status} />
        </Fragment>
      )
    }

    return (<Layout>{content}</Layout>);
  }
}
